import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import LanguageSection from "./components/LanguageSection";
import WelcomeSection from "./components/WelcomeSection";
import WhyThisCourse from "./components/WhyThisCourse";
import CurriculumSection from "./components/CurriculumSection";
import FreeBonusSection from "./components/FreeBonusSection";
import PricingSection from "./components/PricingSection";
import InstructorsSection from "./components/InstructorsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import Footer from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import Dashboard from "./components/Dashboard";
import CoursePage from "./components/CoursePage";
import AdminPanel from "./components/admin/AdminPanel";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#1a1f2e]">
      <Navbar />
      <HeroSection />
      <LanguageSection />
      <WelcomeSection />
      <WhyThisCourse />
      <CurriculumSection />
      <FreeBonusSection />
      <PricingSection />
      <InstructorsSection />
      <TestimonialsSection />
      <Footer />
    </div>
  );
};

// Router wrapper to handle auth callback
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/course" element={<CoursePage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      {/* Hidden admin panel with complex URL */}
      <Route path="/system-panel-x7k9m2p4q8r1-secure" element={<AdminPanel />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <AppRouter />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
